import React from 'react';
import EstadisticasConsolidadoTabla from './EstadisticasConsolidadoTabla';
import styled from 'styled-components/macro';

const EstadisticasConsolidado = props => {
  return (
    <EstConsolidado>
      {props.data.map(x => {
        return <EstadisticasConsolidadoTabla key={x.tipo} data={x} />;
      })}
    </EstConsolidado>
  );
};

const EstConsolidado = styled.section`
width:100%;
  margin-top: 6px;
  background-color: white;
  overflow: auto;
`;

export default EstadisticasConsolidado;
